module.exports = function getResource(label, vars = []) {
    let resources = {
        beautyTraits: 'Beauty Traits',
        beautyTraitsInclude: 'Beauty Traits on your profile include:',
        skinType: 'Skin type',
        skinTone: 'Skin tone',
        hairType: 'Hair type',
        hairColor: 'Hair color',
        eyeColor: 'Eye color',
        colorIQ: 'Color IQ',
        beautyTraitsVisible: 'Beauty Traits on your profile are visible to:',
        everyone: 'Everyone',
        justMe: 'Just me',
        profile: 'Profile',
        yourSkincareConcerns: 'Your skincare concerns and hair concerns are not shown on your public profile.',
        yourProfileVisible: `Your Profile is visible to: ${vars[0] ? 'Just me' : 'Everyone'}`,
        yourBeautyInsider: 'Your Beauty Insider, Lists and Account pages are always private.',
        forMoreInformation: 'For more information, see our',
        termsOfUse: 'Terms of Use'
    };
    return resources[label];
};
